// Respiratory subsection questionnaire constants
export enum RespiratoryQuestionnaireItem {
  MEDICAL_BACKGROUND_RESPIRATORY = 'medical-background/respiratory',
  MEDICAL_BACKGROUND_RESPIRATORY_RESPIRATORY_WNL = 'medical-background/respiratory/respiratory-wnl',
  MEDICAL_BACKGROUND_RESPIRATORY_COUGH = 'medical-background/respiratory/cough',
  MEDICAL_BACKGROUND_RESPIRATORY_OXYGEN = 'medical-background/respiratory/oxygen',
  MEDICAL_BACKGROUND_RESPIRATORY_LUNG_SOUNDS = 'medical-background/respiratory/lung-sounds',
  MEDICAL_BACKGROUND_RESPIRATORY_SYSTEM_SUMMARY = 'medical-background/respiratory/system-summary'
}
